import { render, staticRenderFns } from "./AddComic.vue?vue&type=template&id=6636420b&scoped=true&"
import script from "./AddComic.vue?vue&type=script&lang=js&"
export * from "./AddComic.vue?vue&type=script&lang=js&"
import style0 from "./AddComic.vue?vue&type=style&index=0&id=6636420b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636420b",
  null
  
)

export default component.exports